export const GET_USER = {
  REQUEST: 'GET_USER',
  PENDING: 'GET_USER_PENDING',
  FULFILLED: 'GET_USER_FULFILLED',
  REJECTED: 'GET_USER_REJECTED'
}